// extracted by mini-css-extract-plugin
export default {"swiper":"CustomSlider_swiper__NvvA5","swiper_navigation":"CustomSlider_swiper_navigation__Qxwoj"};